import {getRequest, postRequest, patchRequest, deleteRequest} from "../api";
import {mapReqOptions} from "../utils";

const postObservable = (operation, id, observable) => {
  const data = {
    operation: operation,
    observables: Array.isArray(observable) ? observable : [observable]
  };

  return postRequest(`/casebook/${id}/observables`, data, {
    serverOptions: {privateURL: true},
    queryParams: {wait_for: true}
  });
};

export const createCase = (
  title,
  shortDescription = "",
  description = "",
  observables = []
) => {
  const postData = {
    type: "casebook",
    title: title,
    short_description: shortDescription,
    description: description,
    observables: observables
  };

  return postRequest("/casebook", postData, {
    serverOptions: {privateURL: true},
    queryParams: {wait_for: true}
  });
};

export const getCase = id => {
  return getRequest(`/casebook/${id}`, null, {
    serverOptions: {privateURL: true}
  });
};

export const updateCase = (id, properties) => {
  return patchRequest(`/casebook/${id}`, properties, {
    serverOptions: {privateURL: true},
    queryParams: {wait_for: true}
  });
};

export const deleteCase = id => {
  return deleteRequest(`/casebook/${id}`, null, {
    serverOptions: {privateURL: true},
    queryParams: {wait_for: true}
  });
};

export const getCaseList = (query, options = {}) => {
  const reqData = {
    query,
    ...mapReqOptions(options)
  };

  return getRequest("/casebook/search", reqData, {
    serverOptions: {privateURL: true}
  });
};

export const addObservables = (caseId, observable) => {
  return postObservable("add", caseId, observable);
};

export const removeObservables = (caseId, observable) => {
  return postObservable("remove", caseId, observable);
};

/* Texts */
const postText = (operation, id, text) => {
  const data = {
    operation,
    texts: Array.isArray(text) ? text : [text]
  };

  return postRequest(`/casebook/${id}/texts`, data, {
    serverOptions: {privateURL: true},
    queryParams: {wait_for: true}
  });
};

export const addText = (caseId, text) => {
  return postText("add", caseId, text);
};

export const replaceText = (caseId, text) => {
  return postText("replace", caseId, text);
};

export const removeText = (caseId, text) => {
  return postText("remove", caseId, text);
};
